import React from 'react';
import NumberFormat from 'react-number-format';
import { I18n } from 'react-redux-i18n';

const ApproveLimitComponent = ({
  limits, setLimit, newLimit, removeLimit,
}) => (
  <div className="form-group">
    {limits.length > 0 && limits.map((limit, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <p key={index}>
        {Number(index) + 1}
        {' '}
          -
        {' '}
        {I18n.t('limitTo')}
:
        {' '}
        <NumberFormat
          className="limit-input"
          value={Number(limit.limit)}
          prefix={`${I18n.t('monetarySymbolPrefix')}`}
          thousandSeparator="."
          decimalSeparator=","
          decimalScale={2}
          fixedDecimalScale
          onValueChange={value => setLimit(value, index)}
        />
        {' '}
        <span
          role="button"
          tabIndex={index}
          onKeyDown={() => removeLimit(index)}
          onClick={() => removeLimit(index)}
          className="delete-limit-btn"
        >
          { I18n.t('deleteLimit') }

        </span>
      </p>
    ))}
    <span
      className="add-limit-btn"
      tabIndex={0}
      role="button"
      onClick={newLimit}
      onKeyDown={() => newLimit()}
    >
        +
      {' '}
      { I18n.t('addNewLimit') }

    </span>
  </div>
);

export default ApproveLimitComponent;
